import type { HttpTypes } from '@medusajs/types';
import type { ProductCardVM } from 'types/view-models';
import { getProductPrice } from './get-product-price';

export function toProductCardVM(
  product: HttpTypes.StoreProduct,
): ProductCardVM {
  const { cheapestPrice } = getProductPrice({ product });
  return {
    id: product.id ?? '',
    handle: product.handle ?? '',
    title: product.title ?? '',
    thumbnail: product.thumbnail ?? null,
    images: product.images?.map(({ url }) => ({ url })) ?? null,
    price: cheapestPrice,
  };
}
